import { useTranslation } from "lib/i18n/translation"

const ExportDataInCSV = ({}) => {
	const { c } = useTranslation("common")

	return (
		<>
			<h2 className="overlay-title">{c("export-in-progress")}</h2>
			<p>{c("export-in-progress-email-will-be-sent")}</p>
		</>
	)
}

export default ExportDataInCSV
